import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const user = await login(username, password);
      if (!user) {
        setError('Erreur lors de la connexion: utilisateur non reçu');
        return;
      }
      if (user.role === 'admin' || user.role === 'super_admin') {
        navigate('/dashboard');
      } else if (user.role === 'hotesse') {
        navigate('/hostess');
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(err.message || 'Erreur lors de la connexion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center py-4" style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)' }}>
      <div className="card border-0 shadow-lg mx-auto" style={{ maxWidth: '500px', width: '95%', borderRadius: '20px', background: 'rgba(26, 26, 46, 0.9)', backdropFilter: 'blur(10px)' }}>
        <div className="card-body p-4 p-md-5">
          {/* REAKTOR Logo */}
          <div className="text-center mb-4">
            <div className="d-inline-flex align-items-center justify-content-center rounded-circle shadow-lg mb-3"
              style={{
                width: '80px',
                height: '80px',
                background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                boxShadow: '0 0 20px rgba(255, 215, 0, 0.4)'
              }}>
              <span className="fa-solid fa-bolt fa-2x" style={{ color: '#1a1a2e' }}></span>
            </div>
            <h3 className="mt-2" style={{ color: '#FFD700' }}>REAKTOR</h3>
            <p style={{ color: '#FFA500', fontSize: '0.9rem' }}>La Roue des Emotions</p>
          </div>

          {error && (
            <div className="alert alert-danger mb-3">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label text-light">Nom d'utilisateur</label>
              <input
                type="text"
                className="form-control"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                style={{ background: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 215, 0, 0.3)', color: '#fff' }}
              />
            </div>
            <div className="mb-4">
              <label className="form-label text-light">Mot de passe</label>
              <input
                type="password"
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                style={{ background: 'rgba(255, 255, 255, 0.1)', border: '1px solid rgba(255, 215, 0, 0.3)', color: '#fff' }}
              />
            </div>
            <button
              type="submit"
              className="btn w-100 btn-lg"
              disabled={loading}
              style={{
                background: 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                border: 'none',
                color: '#1a1a2e',
                fontWeight: 'bold',
                borderRadius: '50px'
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Connexion...
                </>
              ) : (
                'Se connecter'
              )}
            </button>
          </form>

          <div className="text-center mt-4">
            <a href="/" style={{ color: '#FFD700' }}>
              <span className="fa-solid fa-arrow-left me-1"></span>
              Retour a l'accueil
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
